import React, { useMemo, useState } from "react";

/* ===================== Données poids ===================== */
const weightCategories = {
  Benjamin: ["-26", "-30", "-34", "-38", "-42", "-46", "-50", "-55", "-60", "-66", "+66 kg"],
  Minime: ["-34", "-38", "-42", "-46", "-50", "-55", "-60", "-66", "-73", "+73 kg"],
  Cadet: ["-46", "-50", "-55", "-60", "-66", "-73", "-81", "-90", "+90 kg"],
  Junior: ["-55", "-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  Sénior: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  BenjaminF: ["-28", "-32", "-36", "-40", "-44", "-48", "-52", "-57", "-63", "+63 kg"],
  MinimeF: ["-36", "-40", "-44", "-48", "-52", "-57", "-63", "-70", "+70 kg"],
  CadetF: ["-40", "-44", "-48", "-52", "-57", "-63", "-70", "+70 kg"],
  JuniorF: ["-44", "-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  SéniorF: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  Eveil: ["Groupes Morphologiques"],
  MiniPoussin: ["Groupes Morphologiques"],
  Poussin: ["Groupes Morphologiques"],
  EveilF: ["Groupes Morphologiques"],
  MiniPoussinF: ["Groupes Morphologiques"],
  PoussinF: ["Groupes Morphologiques"],
  M1: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M2: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M3: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M4: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M5: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M6: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M7: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M8: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M9: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M10: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M11: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  F1: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F2: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F3: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F4: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F5: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F6: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F7: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F8: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F9: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F10: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F11: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
};

/* ===================== Helpers Saison & Années ===================== */
const getCurrentSeasonStartYear = (d = new Date()) => {
  const y = d.getFullYear();
  const m = d.getMonth();
  return m >= 7 ? y : y - 1;
};
const seasonStringFromStartYear = (startYear) => `${startYear}-${startYear + 1}`;
const parseSeasonStartYear = (seasonStr) => parseInt(seasonStr.split("-")[0], 10);

const yearRange = (endYear, minAge, maxAge) => {
  if (maxAge === Infinity) {
    const fromYear = endYear - minAge;
    return `${fromYear} et avant`;
  }
  const start = endYear - maxAge;
  const end = endYear - minAge;
  return `${start} - ${end}`;
};

const AGE_BANDS = [
  { key: "Eveil", labelM: "Eveil", labelF: "Eveil", minAge: 5, maxAge: 6 },
  { key: "MiniPoussin", labelM: "Mini-Poussin", labelF: "Mini-Poussine", minAge: 7, maxAge: 8 },
  { key: "Poussin", labelM: "Poussin", labelF: "Poussine", minAge: 9, maxAge: 10 },
  { key: "Benjamin", labelM: "Benjamin", labelF: "Benjamine", minAge: 11, maxAge: 12 },
  { key: "Minime", labelM: "Minime", labelF: "Minime", minAge: 13, maxAge: 14 },
  { key: "Cadet", labelM: "Cadet", labelF: "Cadette", minAge: 15, maxAge: 17 },
  { key: "Junior", labelM: "Junior", labelF: "Junior", minAge: 18, maxAge: 20 },
  { key: "Sénior", labelM: "Sénior", labelF: "Sénior", minAge: 21, maxAge: Infinity },
];

const VETERANS = [
  { keyM: "M1", keyF: "F1", minAge: 30, maxAge: 34, label: "Vétéran" },
  { keyM: "M2", keyF: "F2", minAge: 35, maxAge: 39, label: "Vétéran" },
  { keyM: "M3", keyF: "F3", minAge: 40, maxAge: 44, label: "Vétéran" },
  { keyM: "M4", keyF: "F4", minAge: 45, maxAge: 49, label: "Vétéran" },
  { keyM: "M5", keyF: "F5", minAge: 50, maxAge: 54, label: "Vétéran" },
  { keyM: "M6", keyF: "F6", minAge: 55, maxAge: 59, label: "Vétéran" },
  { keyM: "M7", keyF: "F7", minAge: 60, maxAge: 64, label: "Vétéran" },
  { keyM: "M8", keyF: "F8", minAge: 65, maxAge: 69, label: "Vétéran" },
  { keyM: "M9", keyF: "F9", minAge: 70, maxAge: 74, label: "Vétéran" },
  { keyM: "M10", keyF: "F10", minAge: 75, maxAge: 79, label: "Vétéran" },
  { keyM: "M11", keyF: "F11", minAge: 80, maxAge: Infinity, label: "Vétéran" },
];

const buildCategoriesForSeason = (seasonStr) => {
  const startYear = parseSeasonStartYear(seasonStr);
  const endYear = startYear + 1;

  const rows = [];
  AGE_BANDS.forEach(({ key, labelM, labelF, minAge, maxAge }) => {
    const annees = yearRange(endYear, minAge, maxAge);
    rows.push({ label: labelM, annees, ageCategory: key, genre: "Masculin" });
    rows.push({ label: labelF, annees, ageCategory: key + "F", genre: "Féminin" });
  });

  VETERANS.forEach(({ keyM, keyF, minAge, maxAge, label }) => {
    const annees = yearRange(endYear, minAge, maxAge);
    rows.push({ label: `${label} ${keyM}`, annees, ageCategory: keyM, genre: "Masculin" });
    rows.push({ label: `${label} ${keyF}`, annees, ageCategory: keyF, genre: "Féminin" });
  });

  return rows;
};

const TableauCategories = () => {
  const defaultSeason = useMemo(
    () => seasonStringFromStartYear(getCurrentSeasonStartYear()),
    []
  );

  const [selectedGenre, setSelectedGenre] = useState("Tous");
  const [selectedAnnee, setSelectedAnnee] = useState("Tous");
  const [season, setSeason] = useState(defaultSeason);

  const categories = useMemo(() => buildCategoriesForSeason(season), [season]);

  const anneesOptions = useMemo(
    () => Array.from({ length: 110 }, (_, i) => (new Date().getFullYear() - i).toString()),
    []
  );

  const filteredCategories = useMemo(() => {
    return categories
      .filter((item) => {
        const matchesGenre = selectedGenre === "Tous" || item.genre === selectedGenre;

        if (selectedAnnee === "Tous") return matchesGenre;

        if (item.annees.includes(" - ")) {
          const [startYearStr, endYearStr] = item.annees.split(" - ");
          const startYear = parseInt(startYearStr.trim(), 10);
          const endYear = parseInt(endYearStr.trim(), 10);
          const year = parseInt(selectedAnnee, 10);
          return matchesGenre && year >= startYear && year <= endYear;
        } else if (item.annees.includes("et avant")) {
          const fromYear = parseInt(item.annees.split("et avant")[0].trim(), 10);
          const year = parseInt(selectedAnnee, 10);
          return matchesGenre && year <= fromYear;
        }
        return matchesGenre;
      })
      .map((item) => {
        const list = weightCategories[item.ageCategory] || ["Non défini"];
        const weightCategoryString = list.includes("Groupes Morphologiques")
          ? "Groupes Morphologiques"
          : list.join(", ");
        return { ...item, weightCategories: weightCategoryString };
      });
  }, [categories, selectedGenre, selectedAnnee]);

  const seasonOptions = useMemo(() => {
    const start = getCurrentSeasonStartYear();
    return [start - 1, start, start + 1, start + 2].map(seasonStringFromStartYear);
  }, []);

  return (
    <section className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-2xl shadow-sm p-6">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100">
          Tableau des catégories d’âges et de poids
        </h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Saison <span className="font-semibold">{season}</span>
        </p>
      </div>

      {/* Filtres */}
      <div className="flex justify-center mb-5 gap-2 flex-wrap">
        <select
          value={season}
          onChange={(e) => setSeason(e.target.value)}
          className="p-2.5 border border-gray-300 rounded-lg bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {seasonOptions.map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>

        <select
          value={selectedGenre}
          onChange={(e) => setSelectedGenre(e.target.value)}
          className="p-2.5 border border-gray-300 rounded-lg bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="Tous">Tous les genres</option>
          <option value="Masculin">Masculin</option>
          <option value="Féminin">Féminin</option>
        </select>

        <select
          value={selectedAnnee}
          onChange={(e) => setSelectedAnnee(e.target.value)}
          className="p-2.5 border border-gray-300 rounded-lg bg-white dark:bg-gray-800 dark:border-gray-700 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="Tous">Toutes les années</option>
          {anneesOptions.map((annee) => (
            <option key={annee} value={annee}>{annee}</option>
          ))}
        </select>
      </div>

      {/* Table responsive avec header sticky */}
      <div className="overflow-x-auto rounded-xl border border-gray-200 dark:border-gray-800">
        <table className="min-w-full bg-white dark:bg-gray-900">
          <thead className="bg-gray-100 dark:bg-gray-800 sticky top-0 z-10">
            <tr>
              <th className="py-3 px-6 text-left text-xs font-semibold uppercase tracking-wide text-gray-600 dark:text-gray-300">
                Catégorie d’âge
              </th>
              <th className="py-3 px-6 text-left text-xs font-semibold uppercase tracking-wide text-gray-600 dark:text-gray-300">
                Genre
              </th>
              <th className="py-3 px-6 text-left text-xs font-semibold uppercase tracking-wide text-gray-600 dark:text-gray-300">
                Années de naissance
              </th>
              <th className="py-3 px-6 text-left text-xs font-semibold uppercase tracking-wide text-gray-600 dark:text-gray-300">
                Catégories de poids
              </th>
            </tr>
          </thead>
          <tbody>
            {filteredCategories.map((row, index) => (
              <tr
                key={`${row.label}-${row.genre}-${index}`}
                className={index % 2 === 0 ? "bg-white dark:bg-gray-900" : "bg-gray-50 dark:bg-gray-950"}
              >
                <td className="py-3 px-6 text-sm text-gray-900 dark:text-gray-100 whitespace-nowrap">
                  {row.label}
                </td>
                <td className="py-3 px-6 text-sm">
                  <span
                    className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-semibold ${
                      row.genre === "Masculin"
                        ? "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-200"
                        : "bg-pink-100 text-pink-700 dark:bg-pink-900/30 dark:text-pink-200"
                    }`}
                  >
                    {row.genre}
                  </span>
                </td>
                <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200">
                  {row.annees}
                </td>
                <td className="py-3 px-6 text-sm text-gray-800 dark:text-gray-200 break-words">
                  {row.weightCategories}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default TableauCategories;
